import { Action } from '@ngrx/store';

export enum RuleActionTypes {
  Load = '[Rule] Load',
  LoadSuccess = '[Rule] Load Success',
  LoadFail = '[Rule] Load Fail',
  Select = '[Rule] Select'
}

export class Load implements Action {
  readonly type = RuleActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = RuleActionTypes.LoadSuccess;
  constructor(public rules: any) {}
}

export class LoadFail implements Action {
  readonly type = RuleActionTypes.LoadFail;
  constructor(public error: any) {}
}

export type RuleActionsUnion = Load | LoadSuccess | LoadFail;
